export enum DIRECTORIES_TAGS {
    /**
     * @value Directory tags
     */
    DIRECTORY_TAGS = 'ADMIN_DIRECTORY_TAGS',
    /**
     * @value Delete a tag
     */
    SELECTED_ITEMS = 'ADMIN_TAG_SELECTED_ITEMS',
    /**
     * @value Are you sure you want to delete this tag?
     */
    SELECTED_ITEMS_DESCRIPTION = 'ADMIN_TAG_SELECTED_ITEMS_DESCRIPTION',
    /**
     * @value Tag deleted
     */
    SELECTED_ITEMS_SUCCESS = 'ADMIN_TAG_SELECTED_ITEMS_SUCCESS',
    /**
     * @value Enter a name
     */
    TAGS_NO_NAME = 'ADMIN_DIRECTORY_TAGS_NO_NAME',
    /**
     * @value Directory tags management
     */
    TAGS_SETTINGS = 'ADMIN_DIRECTORY_TAGS_SETTINGS',
}
